<template>
  <section>
    <ul>
      <li v-for='item in tableList' :key='item.id' :class='{active: item.active}' @mouseover='previewDetail(item)'>
        <img v-if='!item.active' :src="item.imgUrl" alt="">
        <img v-if='item.active' :src="item.imgUrl2" alt="">
        <p>
          <span>{{item.num}}</span>
          <span>{{item.text}}</span>
        </p>
      </li>
    </ul>
    <div class="swiper1">
      <div class="swiper-wrapper">
        <div v-for="(item, index) in banner" :key='index' class="swiper-slide">
          <a target="_blank" :href="item.url"><img :src="item.thumb"/></a>
        </div>
        <!--<div class="swiper-slide">-->
            <!--<a target="_blank" href="http://api.bilaiye.com/uploads/20200401/5202e5bcbab4e9721813b83d00a6a702.png">-->
              <!--<img src="http://api.bilaiye.com/uploads/20200401/5202e5bcbab4e9721813b83d00a6a702.png"/>-->
            <!--</a>-->
        <!--</div>-->
        <!--<div class="swiper-slide">-->
          <!--<a target="_blank" href="http://api.bilaiye.com/uploads/20200401/5202e5bcbab4e9721813b83d00a6a702.png">-->
            <!--<img src="http://api.bilaiye.com/uploads/20200401/039b0e09e1393517fd327fe22ec7991e.png"/>-->
          <!--</a>-->
        <!--</div>-->

        <!--<div class="swiper-button-next"></div>-->
        <!--<div class="swiper-button-prev"></div>-->

      </div>
      <div class="swiper-pagination1">
      </div>
      <!--<div class="swiper-button-next"></div>-->
      <!--<div class="swiper-button-prev"></div>-->

      <!--<ul class="swiper-pagination">-->
        <!--<li class="active"></li>-->
        <!--<li ></li>-->
        <!--<li ></li>-->
        <!--<li></li>-->
      <!--</ul>-->

    </div>
  </section>

</template>
<script>
   import { Api } from '../service/api'
   import Swiper from 'swiper';
  export default {
    name: 'TableNav',
    data () {
      return {
        banner:[],
        tableList: [
          {
            id: 1,
            text: '交易总额',
            num: 0,
            imgUrl: require('../assets/images/icon1.png'),
            imgUrl2: require('../assets/images/icon11.png'),
            active: false
          }, {
            id: 2,
            text: '关键词数量',
            num: 0,
            imgUrl: require('../assets/images/icon6.png'),
            imgUrl2: require('../assets/images/icon61.png'),
            active: false
          }, {
            id: 3,
            text: '用户数量',
            num: 0,
            imgUrl: require('../assets/images/icon2.png'),
            imgUrl2: require('../assets/images/icon21.png'),
            active: false
          }, {
            id: 4,
            text: '昨日上词量',
            num: 0,
            imgUrl: require('../assets/images/icon7.png'),
            imgUrl2: require('../assets/images/icon71.png'),
            active: true
          }, {
            id: 5,
            text: '平均上词时间',
            num: 0,
            imgUrl: require('../assets/images/icon4.png'),
            imgUrl2: require('../assets/images/icon41.png'),
            active: false
          }, {
            id: 6,
            text: '平均达标率',
            num: 0,
            imgUrl: require('../assets/images/icon3.png'),
            imgUrl2: require('../assets/images/icon31.png'),
            active: false
          }, {
            id: 7,
            text: '昨日成交额',
            num: 0,
            imgUrl: require('../assets/images/icon5.png'),
            imgUrl2: require('../assets/images/icon51.png'),
            active: false
          }, 
        ]
      }
    },
    methods: {
      getBanner(){
          let _this = this
          Api.getBanner().then((res)=>{
              this.banner = res.data.data
              _this.$nextTick(function () {
                  new Swiper('.swiper1',
                      {    //初始化Swiper
                          //       pagination:'.swiper1 .swiper-pagination',//分页容器的css选择器

                          //      paginationType: 'custom',//自定义-分页器样式类型（前提）
                          effect : 'flip',
                          autoplay: { //自动切换
                              delay: 2000,
                              stopOnLastSlide: false,
                              disableOnInteraction: false,
                          },
                          navigation: {   //前进后退
                              nextEl: '.swiper-button-next',
                              prevEl: '.swiper-button-prev',
                          },
                          pagination: {   //分页器
                              el: '.swiper-pagination1',
                              clickable :true,
                              //  bulletActiveClass: '',
                          },
                          loop : true,    //循环
                      })
              })

          })
      },
      previewDetail(item){
        this.tableList.map(value => {
          value.active = false
        })
        item.active = true
      },
      getStatistics() {
        let params = {}
        Api.getStatistics(params).then((res) => {
          if(res.data.code == 1){
            this.tableList[0].num = res.data.data.count_money
            this.tableList[1].num = res.data.data.count_key
            this.tableList[2].num = res.data.data.count_user
            this.tableList[3].num = res.data.data.last_key
            this.tableList[4].num = res.data.data.average_time
            this.tableList[5].num = res.data.data.average_stand
            this.tableList[6].num = res.data.data.last_money
          }
          
        })
      }
    },
    mounted() {
      this.getStatistics();
      this.getBanner()
        // var mySwiper = new Swiper('.swiper-container', {
        //     autoplay: true,
        //     speed: 1000,
        //     loop: true,
        //     pagination: '.optimizeCircle',//分页容器的css选择器
        //     paginationType: 'custom',//自定义-分页器样式类型（前提）
        //     navigation: {
        //         nextEl: '.swiper-button-next',
        //         prevEl: '.swiper-button-prev',
        //     },
        //     pagination: {
        //         el: '.swiper-pagination',
        //     },
        //     //设置自定义分页器的内容
        //     paginationCustomRender: function (swiper, current, total) {
        //         var _html = '';
        //         for (var i = 1; i <= total; i++) {
        //             alert(current)
        //             if (current == i) {
        //                 _html += '<li class=" active"></li>';
        //             } else {
        //                 _html += '<li class=""></li>';
        //             }
        //         }
        //         return _html;//返回所有的页码html
        //     }
        // })


    }

  }
</script>
<style lang="scss">
  .swiper-pagination1{
    position: absolute;
    text-align: center;
    -webkit-transition: 300ms opacity;
    -o-transition: 300ms opacity;
    transition: 300ms opacity;
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
    z-index: 10;
  }
  .swiper-container-horizontal > .swiper-pagination-bullets .swiper-pagination-bullet {
    margin: 0 4px;
  }
  .swiper-pagination-bullet-active {
    background: #ff0000 !important;
    opacity: 1 !important;
  }
  .swiper-pagination-bullets{
    bottom: 5px !important;
  }
  .swiper-pagination-bullet {
    width: 8px;
    height: 8px;
    display: inline-block;
    border-radius: 100%;
    background: #000;
    opacity: 0.2;
  }
</style>
<style lang='scss' scoped>
  @import '../../node_modules/swiper/dist/css/swiper.css';


  ul{
    margin: 20px 2.5rem;
    background: #fff;
    display: flex;
    li{
      width: 100%;
      padding: 20px;
      display: flex;
      cursor: pointer;
      background: #fff;
      img{
        width: 30px;
        height: 30px;
        margin-right: 4px;
        margin-top: 4px;
      }
      p{
        span{
          white-space: nowrap;          
          display: block;
          font-size: 12px;
          &:nth-of-type(1){
            font-size: 20px;
            font-weight: 600;
          }
        }
      }
      &.active{
        background: #FC5F35;
        position: relative;
        left: 0;
        top: 0;
        color: #fff;
        &:before{
          content: '';
          display: block;
          width: 100%;
          height: 8px;
          background: #FC5F35;
          position: absolute;
          left: 0;
          top: -8px;
        }
         &:after{
          content: '';
          display: block;
          width: 100%;
          height: 8px;
          background: #FC5F35;
          position: absolute;
          left: 0;
          bottom: -8px;
        }
      }
    }
  }

  section{
    .my-bullet-active{
      background: #ff0000;
      opacity: 1;
    }
    .swiper-pagination-bullet {
      width: 8px;
      height: 8px;
      display: inline-block;
      border-radius: 100%;
      background: #000;
      opacity: 1;
    };
  }
</style>



// WEBPACK FOOTER //
// src/components/TableNav.vue